import React from 'react';
import ReactDOM from 'react-dom/client';

import { BrowserRouter } from 'react-router-dom';

import 'antd/dist/reset.css'; // Khôi phục CSS Ant Design
import './styles/animationVisibility.css';
import { installAnimationVisibility } from './utils/animationVisibility';
import './index.css'; 
import App from './App';
import AppDesignProvider from './theme/AppDesignProvider'; 
import { UserProvider } from './context/UserContext'; // Import UserProvider

const disposeAnimationVisibility = installAnimationVisibility();
if (module.hot) module.hot.dispose(disposeAnimationVisibility);

document.body.classList.add('edutrack-design');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppDesignProvider>
    <UserProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </UserProvider>
    </AppDesignProvider>
  </React.StrictMode>
);